import { type ReactNode } from 'react';
import { useMobileNavSidebar } from '../../hooks/useUserPreferences';

interface MobileSideNavFrameProps {
  children: ReactNode;
}

/**
 * Shared mobile drawer chrome for the left side-nav: backdrop + slide-in
 * container. Desktop keeps the rail always visible via md:translate-x-0.
 */
function MobileSideNavFrame({ children }: MobileSideNavFrameProps) {
  const { showMobileNavSidebar, closeMobileNavSidebar } = useMobileNavSidebar();

  return (
    <>
      {showMobileNavSidebar && (
        <div
          className="z-sidebar-backdrop fixed inset-0 md:hidden"
          onClick={closeMobileNavSidebar}
          data-testid="mobile-side-nav-backdrop"
        />
      )}

      <div
        className={`side-nav-container md:translate-x-0 ${showMobileNavSidebar ? 'translate-x-0' : '-translate-x-full'}`}
        data-testid="mobile-side-nav-frame"
      >
        {children}
      </div>
    </>
  );
}

export default MobileSideNavFrame;
